/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { cartTotalDisplayStyles } from "@monsma/Overrides/Components/CartTotalDisplay";
import { cartTotalStyles } from "@monsma/Overrides/Widgets/Cart/CartTotal";
import { totalStyles } from "@monsma/Overrides/Widgets/InvoiceDetails/InvoiceDetailsTotal";

(totalStyles as any).title = cartTotalStyles.xStyle?.title;

(totalStyles as any).wrapper = cartTotalStyles.xStyle?.wrapper;

totalStyles.container = cartTotalDisplayStyles.container;

totalStyles.valueGridItem = cartTotalDisplayStyles.valueGridItem;

totalStyles.subtotalLabelText = cartTotalDisplayStyles.subtotalLabel;
totalStyles.subtotalValueText = cartTotalDisplayStyles.subtotalLabel;

totalStyles.discountsLabelText = cartTotalDisplayStyles.discountsLabel;
totalStyles.discountsValueText = cartTotalDisplayStyles.discountsValue;

totalStyles.shippingAndHandlingLabelText = cartTotalDisplayStyles.subtotalLabel;
totalStyles.shippingAndHandlingValueText = cartTotalDisplayStyles.subtotalLabel;

totalStyles.otherChargesLabelText = cartTotalDisplayStyles.subtotalLabel;
totalStyles.otherChargesValueText = cartTotalDisplayStyles.subtotalLabel;

totalStyles.taxLabelText = cartTotalDisplayStyles.subtotalLabel;
totalStyles.taxValueText = cartTotalDisplayStyles.subtotalLabel;

(totalStyles as any).labelGridItemTotal = cartTotalDisplayStyles?.xStyle?.labelGridItemTotal;
(totalStyles as any).valueGridItemTotal = cartTotalDisplayStyles?.xStyle?.valueGridItemTotal;
totalStyles.totalLabelText = cartTotalDisplayStyles.totalLabel;
totalStyles.totalValueText = cartTotalDisplayStyles.totalValue;
